// Mutation hook for PATCH /api/sites/:siteId/comms/channels/:channelId/messages/:messageId.
//
// Like delete, the server broadcasts the updated message over WS — this hook
// just fires the REST call; the WS echo is the authoritative UI update.

import { useMutation } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import type { MessageSegment } from '../../interfaces/ICommsApi.js';

interface IEditMessageVars {
  channelId: string;
  messageId: string;
  segments: MessageSegment[];
}

export function useEditMessage(siteId: string) {
  const { editMessage } = useClientApis().comms;
  return useMutation<{ message: unknown }, Error, IEditMessageVars>({
    mutationFn: ({ channelId, messageId, segments }) =>
      editMessage(siteId, channelId, messageId, segments),
  });
}
